import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { StepItemModel, SubmitItem } from '@libs/form/models';
import { DynamicElementsDirective } from '../../../directives';
import { DYNAMIC_ELEMENTS_MAP, GroupBaseComponent } from '../../../models';
import { SubmitGroupComponent } from '../../actions';
import { SingleItemsMap } from '../../single-items-map';
import { InputListComponent } from '../input-list';

@Component({
  selector: 'ui-form-step',
  templateUrl: './step.component.html',
  imports: [
    DynamicElementsDirective,
    SubmitGroupComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [
    {
      provide: DYNAMIC_ELEMENTS_MAP,
      useValue: {
        ...SingleItemsMap,
        list: InputListComponent,
      },
    },
  ],
})
export class StepComponent extends GroupBaseComponent {
  @Input() public data!: StepItemModel;
  @Input() public hideTitle: boolean = false;
  @Output() public readonly submitted: EventEmitter<SubmitItem> = new EventEmitter<SubmitItem>();

  /**
   * Handles submit and emits event.
   */
  public onSubmit(event: SubmitItem): void {
    this.submitted.emit(event);
  }
}
